import { render, staticRenderFns } from "./PCustoManualReport.vue?vue&type=template&id=2ae07c66&scoped=true"
import script from "./PCustoManualReport.vue?vue&type=script&lang=js"
export * from "./PCustoManualReport.vue?vue&type=script&lang=js"
import style0 from "./PCustoManualReport.vue?vue&type=style&index=0&id=2ae07c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae07c66",
  null
  
)

export default component.exports